import { useNavigate } from 'react-router';
import { useConnections } from '../api/hooks';
import { ErrorBanner } from '../components/ErrorBanner';
import { PersonRow } from '../components/PersonRow';
import { ListSkeleton } from '../components/Skeleton';
import { useT } from '../i18n';

export function PickPersonScreen() {
  const t = useT();
  const navigate = useNavigate();
  const q = useConnections();
  return (
    <main className="min-h-dvh bg-bg text-text px-4 py-4 flex flex-col gap-4">
      <h1 className="text-2xl font-semibold">{t.pick.title}</h1>
      {q.isPending && <ListSkeleton />}
      {q.isError && <ErrorBanner error={q.error} onRetry={() => void q.refetch()} />}
      {q.data && q.data.items.length === 0 && <p className="text-hint">{t.pick.empty}</p>}
      {q.data && (
        <section className="divide-y divide-secondary-bg">
          {q.data.items
            .filter((c) => !c.peer.is_deleted)
            .map((c) => (
              <PersonRow
                key={c.id}
                c={c}
                onClick={() => void navigate(`/c/${c.id}/new`, { replace: true })}
              />
            ))}
        </section>
      )}
    </main>
  );
}
